import { render, staticRenderFns } from "./dialogForm1.vue?vue&type=template&id=c4a70d3a&scoped=true"
import script from "./dialogForm1.vue?vue&type=script&lang=js"
export * from "./dialogForm1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a70d3a",
  null
  
)

export default component.exports